import createAction from "../../../actions/safeCreateAction";
export const startDialog = createAction("START_FOMOD_DIALOG", (info, instanceId) => ({
    info,
    instanceId,
}));
export const endDialog = createAction("END_FOMOD_DIALOG", (instanceId) => ({
    instanceId,
}));
export const clearDialog = createAction("CLEAR_FOMOD_DIALOG", (instanceId) => ({
    instanceId,
}));
export const setDialogState = createAction("SET_FOMOD_DIALOG_STATE", (dialogState, instanceId) => ({
    dialogState,
    instanceId,
}));
